import React from "react";
import { Box, Typography } from "@mui/material";
import FrameCard from "../../shared/FrameCard";
import SectionTitle from "../../shared/SectionTitle";
import { TEXT_COLOR_PRIMARY, GRAY_COLOR } from "../../../constants/colors";
import { FONT_SIZE } from "../../../constants/fontSizes";

/**
 * 自己PR・自己実績などのテキスト表示用カード
 *
 * - FrameCard を外枠として使用
 * - タイトル付きセクション
 * - 長文・改行に対応
 */
const ProfileTextCard = ({ title, text }) => {
  const isEmpty = !text;
  return (
    <FrameCard>
      {/* タイトル */}
      <SectionTitle title={title} />

      {/* 本文 */}
      <Box sx={{ mt: 1 }}>
        {isEmpty ? (
          <Typography sx={{ color: GRAY_COLOR }}>未登録です</Typography>
        ) : (
          <Typography
            lineHeight={1.8}
            sx={{
              fontSize: FONT_SIZE.SM,
              color: TEXT_COLOR_PRIMARY,
              whiteSpace: "pre-wrap",
            }}
          >
            {text}
          </Typography>
        )}
      </Box>
    </FrameCard>
  );
};

export default ProfileTextCard;
